<div class="db-payment-methods" [ngClass]="{'demo-user': !!demoUser}">
  <db-ecommerce-payments-intro
    *ngIf="!!demoUser"
    [websiteId]="website?.id"></db-ecommerce-payments-intro>

  <div *ngIf="!demoUser">
    <div class="db-payment-methods__content">
      <div class="db-payment-methods__content-header mb40">
        <div>
          <h1>{{ 'text_paymentMethod' | dbText }}</h1>
          <p class="mt4">{{ 'text_manageSetupAndReorderAllYourPaymentSystemsInOnePlace' | dbText }}<i class="db-icon db-icon-info-lined" [dsTooltip]="paymentSystemTooltip"  [dsTooltipSize]="'large'" [dsTooltipAlign]="'center'"></i></p>
        </div>
      </div>
      <div class="db-payment-methods__content-draggable"
           [ngClass]="{'mt20': !!setupTenWebPayments || !!noOrdersFields, 'mt40': !setupTenWebPayments && !noOrdersFields}"
           [dragula]='"paymentsOrder"'
           [dragulaModel]="paymentsOrder">
        <ng-container
          *ngFor="let section of paymentsOrder; let i = index">
            <db-ecommerce-payment-method-action
              *ngIf="section?.id !== 'tenweb_payments_stripe'"
              (switchStatus)="updateBatchStatus(section?.id, $event)"
              id="{{section?.id}}"
              tabindex="{{i}}"
              [website]="website"
              [needSetup]="section?.needs_setup"
              [enabled]="section?.enabled"
              [elementId]="section?.id"
              [title]="(section?.id === 'woocommerce_payments' ? 'WooPayments - ' : '') + section?.title"
            ></db-ecommerce-payment-method-action>

        </ng-container>
      </div>
    </div>
  </div>
</div>
<db-loading-screen *ngIf="!!pageLoading" [pageBlocker]="true"></db-loading-screen>

<ng-template #paymentSystemTooltip>
  <img src="assets/images/ecommerce/tooltip.svg" alt="" width="100%" height="100%" />
</ng-template>
